import { useAuth } from "@/contexts/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AppShell from "@/components/AppShell";
import AdminSidebar from "@/components/AdminSidebar";
import { ADMIN_ROLES } from "@/lib/roles";

/**
 * App shell for admin pages: the shared sidebar layout with admin navigation.
 * Non-admins who can reach a shared admin route (e.g. interests) keep the plain
 * navigation + content + footer layout.
 */
export default function AdminShell({ children }: { children: React.ReactNode }) {
  const { hasRole } = useAuth();

  if (!hasRole(...ADMIN_ROLES)) {
    return (
      <>
        <Navigation />
        {children}
        <Footer />
      </>
    );
  }

  return <AppShell sidebar={<AdminSidebar />}>{children}</AppShell>;
}
